import { useCallback } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'
import { RadioItemProps } from './types'

export const RadioItem = <T,>({
  onValueChange,
  value,
  children,
  className,
  name,
  ...props
}: RadioItemProps<T>) => {
  const handleChange = useCallback(() => {
    onValueChange(value)
  }, [onValueChange, value])

  return (
    <label className={cn(className, styles.radioLabel)} {...props}>
      <input type="radio" value={String(value)} name={name} onChange={handleChange} />
      {children}
    </label>
  )
}
